// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_43-0";